import Page, { getProps } from 'src/modules/public-service/report'

export const getServerSideProps = getProps

export default Page
